import { Credentials } from "auth";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type AuthCompleteEmailVerification = "AUTH_COMPLETE_EMAIL_VERIFICATION";
export const AUTH_COMPLETE_EMAIL_VERIFICATION: AuthCompleteEmailVerification = "AUTH_COMPLETE_EMAIL_VERIFICATION";

export type AuthCompleteEmailVerificationEnd = "AUTH_COMPLETE_EMAIL_VERIFICATION_END";
export const AUTH_COMPLETE_EMAIL_VERIFICATION_END: AuthCompleteEmailVerificationEnd = "AUTH_COMPLETE_EMAIL_VERIFICATION_END";

export interface AuthCompleteEmailVerificationAction extends Action {
    payload: {
        credentials: Credentials;
    };
    type: AuthCompleteEmailVerification;
}

export function completeEmailVerification(): ThunkAction<any, State, any, AuthCompleteEmailVerificationAction> {
    return (dispatch, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(completeEmailVerificationWithCredentials(credentials));
    };
}

function completeEmailVerificationWithCredentials(credentials: Credentials): AuthCompleteEmailVerificationAction {
    return {
        payload: {
            credentials
        },
        type: AUTH_COMPLETE_EMAIL_VERIFICATION
    };
}

export interface AuthCompleteEmailVerificationEndAction extends Action {
    payload: {
        error?: Error;
    };
    type: AuthCompleteEmailVerificationEnd;
}

export function completeEmailVerificationEnd(error?: Error): AuthCompleteEmailVerificationEndAction {
    return {
        payload: {
            error
        },
        type: AUTH_COMPLETE_EMAIL_VERIFICATION_END
    };
}